import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import axios from "axios";
import { Container } from "reactstrap";
import Domain from "../components/Domain/Domain";
import Country from "../components/Country/Country";
import Uploads from "../components/Uploads/Uploads";
import Users from "../components/User/Users";
import ManageCategories from "../components/Category/ManageCategories";
import AddCountryLanguage from "../components/Country/AddCountryLanguage";
import GameList from "../components/GameDetail/GameList";
import GameDetail from "../components/GameDetail/GameDetail";
import Favorites from "../components/Favorites/Favorites";
import SearchPage from "../components/SearchPage/SearchPage";
import Terms from "../components/Terms/Terms";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import PrivacyPolicyNo from "../components/PrivacyPolicy/PrivacyPolicyNo";
import NewPrivacyPolicy from "../components/NewPrivacyPolicy/NewPrivacyPolicy";
import AboVerwaltung from "../components/StaticPages/AboVerwaltung";
import AGB from "../components/StaticPages/AGB";
import Hilfe from "../components/StaticPages/Hilfe";
import Impressum from "../components/StaticPages/Impressum";
import HomePage from "../components/HomePage/HomePage";
import Account from "../components/Account/Account";
import FlashMessage from "../components/FlashMessage/FlashMessage";
import Login from "../components/Login/Login";
import * as vars from "../constants/variables";
import { getDetails, getInterests } from "../actions/AccountActions";
import {
  getGames,
  getFavouriteGames,
  setFavouriteGames,
} from "../actions/GamesActions";
import { getCategories } from "../actions/CategoryActions";
import { checkAccess, addUid } from "../actions/WelcomeActions";
import { show, hide } from "../actions/ActivityIndicatorActions";
import {
  console_log,
  parseQueryString,
  appendUid,
  getHashQueryParams,
  getParameters,
} from "../utils/helper";
import { config } from "../constants/domainConfig";
import TwoStepLogin from "../components/Login/TwoStepLogin";
import { isGamiclub } from "../constants/isGamiclub";
import { isAppspool } from "../constants/isAppspool";
import { isGamezClan } from "../constants/isGamezClan";
import { sendData } from "../analytics/sendData";
import { shuffle } from "shuffle-seed";
import { isOnlyMobbfun } from "../constants/isOnlyMobbfun";
import { peHEURL } from "../constants/heURL";
import Faq from "../components/Faq/Faq";
import ContactUs from "../components/Faq/ContactUs/ContactUs";
import DemoPage from "../components/DemoPage/DemoPage";
import DemoMaxisWelcome from "../components/DemoPage/DemoMaxisWelcome";
import GameDetailDemo from "../components/GameDetail/GameDetailDemo";
import SubscriptionPlan from "../components/StaticPages/SubscriptionPageMaxis";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.callApis = this.callApis.bind(this);
    this.goToPage = this.goToPage.bind(this);
  }

  redirectToHTML() {
    setTimeout(() => {
      this.props.history.push(`/home/html?uid=${this.props.access.uid}`);
    }, 1000);
  }

  componentWillMount() {
    if (localStorage.getItem("authorized"))
      localStorage.removeItem("authorized");
    if (localStorage.getItem("maxis_email"))
      localStorage.removeItem("maxis_email");
    if (localStorage.getItem("reduxStore"))
      localStorage.removeItem("reduxStore");
    if (
      !JSON.parse(sessionStorage.getItem("authorized")) ||
      !JSON.parse(sessionStorage.getItem("authorized")).success
    ) {
      const is_staging = getParameters("is_staging");
      const uid = getParameters("uid");
      const msisdn = getParameters("msisdn");
      const rid = getParameters("rid");
      const id = getParameters("id");
      const subdomain = config.subDomain;
      const search = window.location.search;
      const isShowLoginTruePE = search.includes("show-login=true");

      sendData("", "", "", "Landed", {});

      if (config.subDomain === "tr") {
        this.props.history.push("/twoStepLogin");
      } else if (config.subDomain === "it") {
        window.location =
          "http://n.game-lords.com/it/super-cars?device=smart&offer=1";
      } else if (config.subDomain === "my" && isGamiclub && !uid.exist && !rid.exist && !msisdn.exist && !id.exist) {  
        this.getCategories()
        .then(() => {
          return this.getGames("fdf098fcc6")
        })
        .then(() => {
          this.setState({ loading: false });
          this.props.history.push("/demo-maxis");
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
          this.props.history.push("/login");
        });
      }
      else if (config.subDomain === "sa" && !isGamiclub && id.exist) {
        axios
          .get(
            `${vars.BASE_URL}/checkAccess?uid=MCB-GSD-${id.value}&subDomain=${subdomain}&domain=${subdomain}.game-lords.com`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              uid: response.data.data.payload.token || `MCB-GSD-${id.value}`,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid,
              });
              this.props.addUid({ uid: data.uid });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getGames(data.uid);
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    this.props.location.pathname + `?uid=${data.uid}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else {
              sendData("", "", "", "Failure", {
                method: "uid",
                success: "false",
              });
              this.setState({ loading: false });
              this.props.history.push("/login");
            }
          })
          .catch((error) => {
            console_log(error);
            this.setState({ loading: false });
          });
      } else if (
        config.subDomain === "za" &&
        is_staging.exist &&
        is_staging.value === "true"
      ) {
        sessionStorage.setItem("staging", is_staging.value);
        axios
          .get(
            `${vars.BASE_URL}/checkAccessStaging?uid=${uid.value}&subDomain=${subdomain}`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              uid: uid.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid,
              });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getGames(this.props.access.uid);
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    `${this.props.location.pathname}?uid=${data.uid}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else {
              sendData("", "", "", "Failure", {
                method: "uid",
                success: "false",
              });
              this.setState({ loading: false });
              this.props.history.push("/login");
            }
          })
          .catch((error) => {
            sendData("", "", "", "Failure", {
              method: "uid",
              success: "false",
            });
            console_log(error);
            this.setState({ loading: false });
          });
      } else if (
        config.subDomain === "za" &&
        uid.exist &&
        rid.exist &&
        !isGamiclub &&
        !isAppspool &&
        !isGamezClan
      ) {
        console.log("validation for uid and rid");
        axios
          .get(
            `${vars.BASE_URL}/checkAccess?uid=${uid.value}&subDomain=${subdomain}`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              uid: uid.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid,
              });
              this.props.addUid({ uid: data.uid });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getGames(data.uid);
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    this.props.location.pathname + `?uid=${data.uid}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else if (rid.exist) {
              axios
                .get(
                  `${vars.BASE_URL}/checkAccessWithRID?rid=${rid.value}&subDomain=${subdomain}`
                )
                .then((response) => {
                  let data = {
                    success: response.data.success,
                    uid: response.data.data.payload.token,
                    token: response.data.data.token,
                    subscriptionData: response.data.data.payload,
                  };
                  sessionStorage.setItem("authorized", JSON.stringify(data));
                  this.props.checkAccess(data);
                  if (response.data.success) {
                    sendData("", "", "", "Accessed", {
                      method: "rid",
                      success: "true",
                      uid: data.uid,
                    });
                    this.props.addUid({ uid: data.uid });
                    axios.defaults.headers.common["authorization"] =
                      response.data.data.token;
                    this.callApis()
                      .then(() => {
                        return this.getCategories();
                      })
                      .then(() => {
                        return this.getGames(data.uid);
                      })
                      .then(() => {
                        return this.getFavouriteGames();
                      })
                      .then(() => {
                        this.setState({ loading: false });
                        this.props.history.push(
                          this.props.location.pathname + `?uid=${data.uid}`
                        );
                      })
                      .catch((err) => {
                        console.log(err);
                        this.setState({ loading: false });
                        this.props.history.push("/login");
                      });
                  } else {
                    sendData("", "", "", "Failure", {
                      method: "rid",
                      success: "false",
                    });
                    this.setState({ loading: false });
                    this.props.history.push("/login");
                  }
                })
                .catch((error) => {
                  console_log(error);
                  this.setState({ loading: false });
                });
            }
          })
          .catch((error) => {
            console_log(error);
            this.setState({ loading: false });
          });
      } else if (config.subDomain === "kw" && id.exist && isGamiclub) {
        const free_uid = "fdf098fcc6";
        axios
          .get(
            `${vars.BASE_URL}/checkAccess?uid=${free_uid}&subDomain=${subdomain}`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              uid: free_uid,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid,
              });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getGames(this.props.access.uid);
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    `${this.props.location.pathname}?uid=${data.uid}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else {
              sendData("", "", "", "Failure", {
                method: "uid",
                success: "false",
              });
              this.setState({ loading: false });
              this.props.history.push("/login");
            }
          })
          .catch((error) => {
            console_log(error);
            this.setState({ loading: false });
          });
      } else if (msisdn.exist) {
        const local_domain = isGamiclub
          ? `${subdomain}.gamiclub.com`
          : `${subdomain}.game-lords.com`;
        const domain = window.location.hostname.includes("localhost")
          ? local_domain
          : window.location.hostname;
        axios
          .get(
            `${vars.BASE_URL}/checkAccessWithMsisdn?msisdn=${msisdn.value}&domain=${domain}`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "msisdn",
                status: "success",
                msisdn: msisdn,
              });
              this.props.addUid({ uid: data.subscriptionData.token });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  return this.getGames(data.subscriptionData.token);
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    this.props.location.pathname +
                      `?uid=${data.subscriptionData.token}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else {
              sendData("", "", "", "Failure", {
                method: "msisdn",
                success: "false",
              });
              this.setState({ loading: false });
              if (config.subDomain === "pe" && !isGamiclub) {
                if (isShowLoginTruePE) this.props.history.push("/login");
                else window.location.replace(peHEURL);
              } else this.props.history.push("/login");
            }
          })
          .catch((error) => {
            console_log(error);
            sendData("", "", "", "Failure", {
              method: "msisdn",
              success: "false",
            });
            this.setState({ loading: false });
          });
      } else if (rid.exist) {
        console.log("check only for rid");
        axios
          .get(
            `${vars.BASE_URL}/checkAccessWithRID?rid=${rid.value}&subDomain=${subdomain}`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              uid: response.data.data.payload.token,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "rid",
                success: "true",
                uid: data.uid,
              });
              this.props.addUid({ uid: data.uid });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getGames(data.uid);
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    this.props.location.pathname + `?uid=${data.uid}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else {
              sendData("", "", "", "Failure", {
                method: "rid",
                success: "false",
              });
              this.setState({ loading: false });
              if (config.subDomain === "pe" && !isGamiclub) {
                if (isShowLoginTruePE) this.props.history.push("/login");
                else window.location.replace(peHEURL);
              } else this.props.history.push("/login");
            }
          })
          .catch((error) => {
            console_log(error);
            this.setState({ loading: false });
          });
      } else if (uid.exist) {
        axios
          .get(
            `${vars.BASE_URL}/checkAccess?uid=${uid.value}&subDomain=${subdomain}`
          )
          .then((response) => {
            let data = {
              success: response.data.success,
              uid: uid.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload,
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            this.props.checkAccess(data);
            if (response.data.success) {
              sendData("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid,
              });
              this.props.addUid({ uid: data.uid });
              axios.defaults.headers.common["authorization"] =
                response.data.data.token;
              this.callApis()
                .then(() => {
                  return this.getCategories();
                })
                .then(() => {
                  return this.getGames(data.uid);
                })
                .then(() => {
                  return this.getFavouriteGames();
                })
                .then(() => {
                  this.setState({ loading: false });
                  this.props.history.push(
                    this.props.location.pathname + `?uid=${data.uid}`
                  );
                })
                .catch((err) => {
                  console.log(err);
                  this.setState({ loading: false });
                  this.props.history.push("/login");
                });
            } else {
              sendData("", "", "", "Failure", {
                method: "rid",
                success: "false",
              });
              this.setState({ loading: false });
              if (config.subDomain === "pe" && !isGamiclub) {
                if (isShowLoginTruePE) this.props.history.push("/login");
                else window.location.replace(peHEURL);
              } else this.props.history.push("/login");
            }
          })
          .catch((error) => {
            console_log(error);
            this.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
        if (config.subDomain === "pe" && !isGamiclub) {
          if (isShowLoginTruePE) this.props.history.push("/login");
          else window.location.replace(peHEURL);
        } else this.props.history.push("/login");
      }
    } else {
      this.setState({ loading: false });
      this.props.history.push(
        this.props.location.pathname + this.props.location.search
      );
    }
  }

  goToPage(path) {
    if (this.props.location.pathname != path) {
      this.props.history.push(appendUid(path, this.props.access.uid));
    }
  }

  callApis() {
    return new Promise((resolve, reject) => {
      if (this.props.account.interests.length <= 0) {
        const uid =
          parseQueryString(this.props.location.search)["uid"] ||
          this.props.access.uid;
        axios
          .all([axios.get(`${vars.BASE_URL}/interests?uid=${uid}`)])
          .then(
            axios.spread((interests) => {
              // for interests
              if (interests.data.data) {
                this.props.getInterests(interests.data.data);
              }
              resolve();
            })
          )
          .then(() => {
            axios
              .get(`${vars.BASE_URL}/getUserProfile?uid=${uid}`)
              .then((resp) => {
                if (resp.data.data) {
                  this.props.getDetails(resp.data.data);
                }
              })
              .catch((err) => {
                console.log("error in getting user profile-------- ", err);
              });
          })
          .catch((err) => {
            console_log(err);
            reject(err);
          });
      } else {
        this.props.getDetails(this.props.account.user);
        this.props.getInterests(this.props.account.interests);
        resolve();
      }
    });
  }

  getCategories() {
    return new Promise((resolve, reject) => {
      axios
        .get(vars.BASE_URL + "/getCategories")
        .then((response) => {
          if (response.data.success) {
            let dataFinal = response.data;
            let categoriesArr = dataFinal.data;
            dataFinal = { ...dataFinal, data: categoriesArr };
            if (config.subDomain === "za" && !isGamiclub) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryTypeId != 4;
              });
            }
            if (
              config.subDomain == "sa" ||
              config.subDomain == "iq" ||
              config.subDomain == "asiacell" ||
              config.subDomain == "qa"
            ) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "New Arrivals";
              });
            }
            if (!(config.subDomain === "ch" && isGamiclub)) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "Astrology";
              });
            }
            if (!(config.subDomain === "cz" && isGamiclub)) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "E-knihy";
              });
            }
            if (config.subDomain === "fr" && isGamiclub) {
              dataFinal.data = dataFinal.data.filter((category) => {
                let excludes = ["Heróis Verdes", "Meu Emprego dos Sonhos"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (
              config.subDomain === "my" && window.location.hostname.includes("gamiclub")) {
              dataFinal.data = dataFinal.data.filter((category) => {
                let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if(config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
              dataFinal.data = dataFinal.data.filter(category => {
                  let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"]
                  return excludes.indexOf(category.categoryName) == -1
              })
            }
            else {
              dataFinal.data = dataFinal.data.filter(category => {
                  return category.categoryName != 'Videos Virales'
              })
            }
            if (config.subDomain !== "rs") {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "Е-књиге";
              });
            }
            if (config.subDomain !== "ae") {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "IQ Games";
              });
            }
            if (
              config.subDomain != "sa" &&
              config.subDomain != "iq" &&
              (config.subDomain != "kw" || !isGamiclub) &&
              config.subDomain != "ae" &&
              config.subDomain != "bh"
            ) {
              dataFinal.data = dataFinal.data.filter((category) => {
                let excludes = [
                  "Motivation",
                  "Tour",
                  "Fun Gaming",
                  "Athletics",
                ];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (config.subDomain != "kw") {
              dataFinal.data = dataFinal.data.filter((category) => {
                let excludes = [
                  "How It Works",
                  "Alwan lara",
                  "Chef Chadi Zeitouni Healthy Food",
                  "Food Stories",
                  "Maalem Hawl Al Aalam",
                  "Maza Na2kol",
                  "Modon men al 3alam",
                  "Modon Men Asia",
                  "Modon Wa Amaken",
                  "Oumam Amthalokom",
                  "Riyad Al Saleheen",
                ];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (config.subDomain != "sn") {
              dataFinal.data = dataFinal.data.filter((category) => {
                let excludes = [
                  "Cuisine",
                  "Musique",
                  "Apprends le français",
                  "Courts métrages",
                  "Visites",
                ];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            /*if(config.subDomain != 'my'){
                                dataFinal.data = dataFinal.data.filter((category) => {
                                     let excludes = ['Casual', 'Adrenaline Rush']
                                     return excludes.indexOf(category.categoryName) == -1
                                })
                            }*/
            /*if(config.subDomain === 'my'){
                                dataFinal.data = dataFinal.data.filter((category) => {
                                    if(category.categoryTypeName !== 'HTML5') { 
                                        return category;
                                    }    
                                    else {
                                        let excludes = ['Premium Games', 'Sports']
                                        return excludes.indexOf(category.categoryName) == -1
                                    }
                                })
                            }*/
            if (
              config.subDomain !== "ae" &&
              (config.subDomain !== "kw" || !isGamiclub)
            ) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName !== "Squid Games";
              });
            }
            if (
              config.subDomain != "maxis" &&
              config.subDomain != "my" &&
              config.subDomain != "sa" &&
              !isGamiclub &&
              config.subDomain != "ae" &&
              !isGamiclub
            ) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "Utilities";
              });
            }
            if (config.subDomain != "idsale" || config.subDomain != "gmn") {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "On Sale";
              });
            }
            if (
              config.subDomain !== "tr" &&
              config.subDomain !== "qa" &&
              config.subDomain !== "kw"
            ) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "Facebook";
              });
            }
            if (config.subDomain == "idsale" || config.subDomain === "gmn") {
              dataFinal.data = dataFinal.data.sort((category) => {
                if (category.categoryName == "On Sale") return -1;
                else return 1;
              });
            }
            if (config.subDomain === "kw" && !isGamiclub) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return (
                  [
                    "How It Works",
                    "Alwan lara",
                    "Chef Chadi Zeitouni Healthy Food",
                    "Food Stories",
                    "Maalem Hawl Al Aalam",
                    "Maza Na2kol",
                    "Modon men al 3alam",
                    "Modon Men Asia",
                  ].indexOf(category.categoryName) < 0
                );
              });
            }
            if (!(config.subDomain == "es2")) {
              dataFinal.data = dataFinal.data.filter((category) => {
                return category.categoryName != "Heroes";
              });
            }
            if (config.subDomain === "sn") {
              dataFinal.data = dataFinal.data.filter((category) => {
                if (category.categoryTypeName !== "VIDEO") return category;
                else
                  return [
                    "Cuisine",
                    "Musique",
                    "Apprends le français",
                    "Courts métrages",
                    "Visites",
                  ].includes(category.categoryName);
              });
            }
            if (config.subDomain === "id" && isOnlyMobbfun) {
              dataFinal.data = shuffle(dataFinal.data, "rzt457");
            }
            if (config.subDomain !== "pt" && !isGamiclub) {
              dataFinal.data = dataFinal.data.filter(
                (category) =>
                  ["Heróis Verdes", "Meu Emprego dos Sonhos"].indexOf(
                    category.categoryName
                  ) < 0
              );
            }
            //if(config.subDomain === 'my'){
            dataFinal.data = dataFinal.data.filter((category) => {
              if (category.categoryTypeName !== "HTML5") {
                return category;
              } else {
                let excludes = ["Premium Games", "Sports"];
                return excludes.indexOf(category.categoryName) == -1;
              }
            });
            //}
            this.props.getCategories(dataFinal);
            resolve();
          }
        })
        .catch((error) => {
          console_log(error);
          this.setState({
            isValid: false,
            errorMessage: "Unable to fetch the data.",
          });
          reject(error);
        });
    });
  }

  getGames(uid) {
    return new Promise((resolve, reject) => {
      axios
        .get(vars.BASE_URL + "/getGames?uid=" + uid)
        .then((response) => {
          if (response.data.success) {
            if (!(config.subDomain == "tr" || config.subDomain == "no")) {
              response.data.data = response.data.data.filter((game) => {
                return (
                  game.gameTitle != "Trusted Tarot" &&
                  game.gameTitle != "Coffee Reading"
                );
              });
            }
            if (config.subDomain == "no") {
              response.data.data = response.data.data.map((game) => {
                return game.gameId == 455
                  ? { ...game, gameTitle: "Coffee Reading" }
                  : game;
              });
            }
            if (config.subDomain != "tr") {
              response.data.data = response.data.data.filter((game) => {
                return game.gameTitle != "Okey";
              });
            }
            if (config.subDomain === "eg") {
              const excluded_games = [
                "Santa Claus The Pervert Part 1",
                "Place your bets! GTA is getting a real virtual casino",
                "Dargavs Welcome to the City of the Dead",
                "King Bacon Vs Vegans",
                "Jackpot",
                "Christmas Night Of Horror",
                "High Fly Valentine",
                "Horoscope",
                "Sacra Terra Kiss Of Death",
                "Haunted Legends Undertaker",
                "Stereotypo",
              ];
              response.data.data = response.data.data.filter((game) => {
                return excluded_games.indexOf(game.gameTitle) < 0;
              });
            }
            if (config.subDomain === "ae" && !isGamiclub) {
              const included_games = ["VPN", "BestVPN"];
              const excluded_games = response.data.data
                .filter((game) => {
                  return (
                    game.categoryName == "Utilities" &&
                    included_games.indexOf(game.gameTitle) < 0
                  );
                })
                .map((game) => game.gameTitle);
              response.data.data = response.data.data.filter((game) => {
                return excluded_games.indexOf(game.gameTitle) < 0;
              });
            }
            if (!(config.subDomain === "gh" || config.subDomain === "ci")) {
              response.data.data = response.data.data.filter((game) => {
                return game.gameTitle != "Fidget Pop It";
              });
            }
            if (config.subDomain !== "demo") {
              const excluded = [
                "Balancer Ball 3D",
                "Bottle Knock Down",
                "Brain For Monster Truck",
                "Bull Fight",
                "Dogs Quiz",
                "Forsake The Rake",
                "Fruit Slice",
                "Horse Quiz",
                "Knock Down",
                "Physics Line",
                "Pixel Art",
                "Sheep Fight",
                "Slenderman Must Die Abandoned Graveyard",
                "Tough Muscle Man",
                "Unicorn Dash",
              ];
              response.data.data = response.data.data.filter((game) => {
                return excluded.indexOf(game.gameTitle) < 0;
              });
            }
            if (config.subDomain === "demo") {
              const excluded = [
                "Box Race",
                "Pacman",
                "Don't Miss",
                "Earth Attack",
                "Memory Game",
                "Mathematic",
                "Office Horror Story",
                "Rise Up",
                "Shadow Ninja",
                "Square Adventure",
                "Super Color Lines",
                "NINJA CLAN",
                "Fidget Spinner",
                "Snake Attack",
                "King Bacon Vs Vegans",
                "CATS VS DOGS",
                "Legend Of The Samurai",
                "Zombo",
                "CANDY GIRL",
                "Flappy Bird Multiplayer",
                "RUN, VOVAN, RUN",
                " BOX TOWER",
                "Connect 4",
                "Four Colors",
                "Math Game",
                "Slice Fruit",
                "Goose Game",
              ];
              response.data.data = response.data.data.filter((game) => {
                return excluded.indexOf(game.gameTitle) < 0;
              });
            }
            if (config.subDomain !== "pe" && config.subDomain!== 'tr') {
              const excluded = [
                "Photo Text Editor",
                "Photo Editor Application",
                "Pic Shop",
                "Retro Cam Pro",
                "Facial Twin Editor",
                "Valentine Love Mesh",
                "Love Photo",
                "Wild Side App",
              ];
              response.data.data = response.data.data.filter((game) => {
                return excluded.indexOf(game.gameTitle) < 0;
              });
            }
            if (config.subDomain !== "gr" && config.subDomain!== 'cz' && config.subDomain!== 'ch' && config.subDomain!== 'fr') {
              const excluded = [
                "PDF Merger",
                "QR Scanner"
              ];
              response.data.data = response.data.data.filter((game) => {
                return excluded.indexOf(game.gameTitle) < 0;
              });
            }
            if (config.subDomain === "pe") {
              const excluded = [
                "Brain it on the truck",
                "Don't Miss",
                "Pacman",
                "Earth Attack",
                "Brain For Monster Truck",
              ];
              response.data.data = response.data.data.filter((game) => {
                if (
                  game.categoryName === "Adventure" &&
                  game.gameTitle === "Rise Up"
                ) {
                  return false;
                }
                return excluded.indexOf(game.gameTitle) < 0;
              });
            }
            this.props.getGames(response.data);
          }
          resolve();
        })
        .catch((error) => {
          console_log(error);
          this.setState({
            isValid: false,
            errorMessage: "Unable to fetch the data.",
          });
          reject(error);
        });
    });
  }

  getFavouriteGames() {
    const uid =
      parseQueryString(this.props.location.search)["uid"] ||
      this.props.access.uid;
    axios
      .get(vars.BASE_URL + "/getFavorites?uid=" + uid)
      .then((response) => {
        if (response.data.success) {
          this.props.getFavouriteGames(response.data);
        }
      })
      .catch((error) => {
        console.log("error in getting favs!!", error);
      });
  }

  render() {
    if (this.props.search.searchText != "") {
      return (
        <SearchPage
          goToPage={this.goToPage}
          path={this.props.location.pathname}
        />
      );
    } else {
      if (this.state.loading) {
        return (
          <div className="activity-indicator">
            {" "}
            <img
              className={isGamiclub ? "icon-loader-gamiclub" : "icon-loader"}
              src={isGamiclub ? "./img/ball-triangle.svg" : "./img/g-icon.svg"}
              alt="Loading..."
            />
          </div>
        );
      } else {
        return (
          <main className="home main">
            <FlashMessage path={this.props.location.pathname} />
            <Container>
              <Switch>
                <Route path="/domain" name="Domain" component={Domain} />
                <Route path="/country" name="Country" component={Country} />
                <Route
                  path="/manage-country"
                  name="AddCountryLanguage"
                  component={AddCountryLanguage}
                />
                <Route path="/manage-user" name="Users" component={Users} />
                <Route
                  path="/manage-categories"
                  name="ManageCategories"
                  component={ManageCategories}
                />
                <Route path="/uploads" name="Uploads" component={Uploads} />
              </Switch>
            </Container>
            <Switch>
              <Route
                path="/category/:categoryId"
                name="GameList"
                component={GameList}
              />
              <Route
                path="/detail/:gameId"
                name="GameDetail"
                component={GameDetail}
              />
              <Route
                path="/play-maxis/:gameId"
                name="GameDetailDemo"
                component={GameDetailDemo}
              />
              <Route path="/favorites" name="Favorites" component={Favorites} />
              <Route path="/search" name="SearchPage" component={SearchPage} />
              <Route path="/terms-conditions" name="Terms" component={Terms} />
              <Route
                path="/privacy-policy"
                name="PrivacyPolicy"
                component={
                  config.subDomain === "es" && !isGamiclub
                    ? NewPrivacyPolicy
                    : PrivacyPolicy
                }
              />
              <Route
                path="/privacy-policy-no"
                name="PrivacyPolicyNo"
                component={PrivacyPolicyNo}
              />
              <Route
                path="/abo-verwaltung"
                name="AboVerwaltung"
                component={AboVerwaltung}
              />
              <Route path="/subscription-maxis" name="AGB" component={SubscriptionPlan} />
              <Route path="/agb" name="AGB" component={AGB} />

              <Route path="/hilfe" name="Hilfe" component={Hilfe} />
              <Route path="/impressum" name="Impressum" component={Impressum} />
              <Route path="/maxis-welcome" name="DemoMaxisWelcome" component={DemoMaxisWelcome} />
              <Route path="/demo-maxis" name="DemoPage" component={DemoPage} />
              <Route path="/home" name="HomePage" component={HomePage} />
              <Route path="/account" name="MyAccount" component={Account} />
              <Route
                path="/twoStepLogin"
                name="TwoStepLogin"
                component={TwoStepLogin}
              />
              <Route path="/faq" name="faq" component={Faq} />
              <Route
                path="/contact-us"
                name="ContactUs"
                component={ContactUs}
              />
              <Route path="*" component={Login} />
            </Switch>
          </main>
        );
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AuthenticationReducer,
    access: state.WelcomeReducer,
    loader: state.ActivityIndicatorReducer,
    domains: state.DomainReducer,
    country: state.CountryReducer,
    users: state.UsersReducer,
    search: state.SearchReducer,
    account: state.AccountReducer,
    categories: state.CategoryReducer,
    games: state.GamesReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      checkAccess,
      addUid,
      getDetails,
      getInterests,
      getGames,
      getCategories,
      getFavouriteGames,
      setFavouriteGames,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js